import type { ConditionStyleId } from '@alltrails/maps/types/Styles';
import ConditionType from '../types/ConditionType';

const conditionStyleIdToConditionType = (styleId: ConditionStyleId): ConditionType | undefined => {
  switch (styleId) {
    case 'precipitation':
      return 'precipitation_intensity';
    case 'snowDepth':
      return 'snow_depth';
    case 'temperature':
      return 'temperature';
    default:
      return undefined;
  }
};

export default conditionStyleIdToConditionType;
